import { render, staticRenderFns } from "./OffersDisplay.vue?vue&type=template&id=6d604d82&scoped=true"
import script from "./OffersDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./OffersDisplay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OffersDisplay.vue?vue&type=style&index=0&id=6d604d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d604d82",
  null
  
)

export default component.exports